function encodeFiles(files, self, callback) {

    let count = files.length;
    let attachments = [];

    for (var i = 0; i < files.length; i++) {
        
        let file = files[i];

        let reader = new FileReader();

        reader.addEventListener('load', function (event) {

            // Remove: data:*/*;base64,
            let content = event.target.result.split(';base64,').pop();
            
            let attachment = {
                type: "upload",
                url: null,
                "content-type": file.type,
                filename: file.name,
                size: file.size,
                content: content 
            };

            attachments.push(attachment);
        });
        
        reader.addEventListener('loadend', function () {
            count--;

            if (count == 0) {
                callback(attachments, self);
            }
        });

        reader.readAsDataURL(file);

    }

}

export { encodeFiles };
